// Hero art for /chapter/:id and the landing “four chapters” grid — keep in sync.

export const CHAPTER_HERO_IMAGES = {
  ttc: '/images/chapter-heroes/cycle.png',
  fertility: '/images/chapter-heroes/fertility.png',
  pregnancy: '/images/chapter-heroes/pregnancy.png',
  postpartum: '/images/chapter-heroes/postpartum.png',
};

export const CHAPTER_HERO_IMAGE_ALTS = {
  ttc: 'Women supporting each other on their TTC journey',
  fertility: 'Three diverse women embracing in friendship',
  pregnancy: 'Pregnant belly with loving hands forming a heart',
  postpartum: 'Mother lifting her toddler with joy outdoors',
};

export function heroImageForChapter(id) {
  return CHAPTER_HERO_IMAGES[id] || CHAPTER_HERO_IMAGES.fertility;
}

export function heroImageAltForChapter(id) {
  return CHAPTER_HERO_IMAGE_ALTS[id] || 'Chapter hero';
}
